import React from 'react';
import GeneralModal from '../../../../components/UI/modal/GeneralModal';
import useTags from '../../../../hooks/useTags';
import checkPermitStatusModalLang from '../../../../data/lang/homePage/checkPermitStatusModal.lang';
import { useClosePermitValidationDateModal, useGetValidationDateModalPVD, useIsOpenModalPVD } from '../../../../stores/permitValidationDateModal.store';


const CheckPermitStatusModal = () => {

    const closePermitValidationDateModal = useClosePermitValidationDateModal();
    const isPermitValidationDateModalOpen = useIsOpenModalPVD();
    const permitValidationDate = useGetValidationDateModalPVD();
    
    const generateTag = useTags();
    const modalTitleTag = generateTag(checkPermitStatusModalLang, 'modal-title');
    const permitEndDateDescriptionTag = generateTag(checkPermitStatusModalLang, 'permit-end-date-description');

    return (
        <GeneralModal
            show={isPermitValidationDateModalOpen}
            closingFunc={closePermitValidationDateModal}
            title={modalTitleTag}
            modalSize='S'
            body={(
                <div className='p-4 fs-3 text-center'>
                    <span>{permitEndDateDescriptionTag}</span>&nbsp;
                    <span className='fst-italic text-decoration-underline fw-medium'>{permitValidationDate}</span>
                </div>
            )}
        />
    );
}

export default CheckPermitStatusModal;